import { useEffect, useState } from 'react'
import { Button, Badge } from 'react-bootstrap'
import Switch from '@material-ui/core/Switch'
import DnsIcon from '@material-ui/icons/Dns'
import api from '../../services/api'
function refreshPage(info) {
  window.location.reload(info)
}
const Corpobackup = ({ data }) => {
  const [check, setCheck] = useState(data.check_bkp)
  const [checkSt, setCheckSt] = useState('Não conferido')
  const [status, setStatus] = useState('success')
  const [field, setField] = useState('')
  const [bgColor, setBgColor] = useState('')
  const [statusName, setStatusName] = useState('')

  useEffect(() => {
    if (data.success != 0){
      setStatus('danger')
      setStatusName(`Erro codigo: ${data.success}`)
    }else{
      setStatus('success')
      setStatusName(`Ok`)
    }
  })
  useEffect(() => {
    if (data.check_bkp != 0) setCheckSt('Conferido')
  })
  const handleChange = async () => {
    if (check === 1) {
      setCheck(0)
      await api.post('/scripts/check', {
        id: data.id,
        check: 0,
      })
    } else {
      await api
        .post('/scripts/check', {
          id: data.id,
          check: 1,
        })
        .then(() => {
          console.log('deu')
        })
      setCheck(1)
    }
  }
  useEffect(() => {
    if (data.size) {
      return setField(data.size)
    } else if (data.files) {
      return setField(data.files)
    } else if (data.disc_space) {
      setField(data.disc_space)
      setBgColor('danger')
      return
    } else if (data.success) {
      return setField(data.success)
    } else {
      setField('Error')
    }
  })

  return (
    <tbody>
      <tr>
        <td>{data.host}</td>
        <td>{data.backup}</td>
        <td>{field}</td>
        <td>
          <Button variant={status}>
            {' '}
            <Badge pill> {statusName}</Badge>
          </Button>
        </td>
        <td style={{ maxWidth: '1rem' }}>
          <Switch
            color="primary"
            checked={check}
            onChange={handleChange}
            name="checkedA"
            inputProps={{ 'aria-label': 'secondary checkbox' }}
          />
        </td>
      </tr>
    </tbody>
  )
}

export default Corpobackup
